/**
 * store search condition of transport service
 */
const state = {
  recommendSearchCondition: null
};

const getters = {
  recommendSearchCondition: state => state.recommendSearchCondition
};

const mutations = {
  saveRecommendSearchCondition(state, recommendSearchCondition) {
    if (!recommendSearchCondition) {
      return;
    }
    state.recommendSearchCondition = recommendSearchCondition;
  },
  clearRecommendSearchCondition(state) {
    state.recommendSearchCondition = null;
  }
};

export default {
  state,
  getters,
  mutations
};
